import TokenReducer from './Token'
import LoadingReducer from './isLoading'
import SnackReducer from './showSnack'
import ModalPassReducer from './showModalPass'
import OwnerReducer from './Owner'
import {combineReducers} from 'redux'
import RoleReducer from './Role'
import PermissionReducer from './Permisson'
import UserReducer from './user'
import ModalConditionReducer from './showModalCondition'

const allReducer = combineReducers({
    token:TokenReducer,
    isLoading:LoadingReducer,
    showSnack:SnackReducer,
    showModal:ModalPassReducer,
    showModalCondition:ModalConditionReducer,
    owner :OwnerReducer,
    permission:PermissionReducer,
    role:RoleReducer,
    userCurrent:UserReducer
})

export default allReducer